import { fetchWithAuth } from '../utils/fetchWithAuth';

export const getAllAgreements = async () => {
  try {
    const response = await fetchWithAuth('/agreements', {
      method: 'GET',
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const createAgreement = async (agreementData) => {
  try {
    const formData = new FormData();
    formData.append("title", agreementData.title);
    formData.append("description", agreementData.description);
    formData.append("contact", agreementData.contact);
    formData.append("business_name", agreementData.company);
    if (agreementData.image) {
      formData.append("image", agreementData.image);
    }

    const response = await fetchWithAuth('/agreements', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error al añadir el acuerdo:", error);
    throw error;
  }
};

export const updateAgreement = async (agreementData) => {
  try {
    const formData = new FormData();
    formData.append("title", agreementData.title);
    formData.append("description", agreementData.description);
    formData.append("contact", agreementData.contact);
    formData.append("business_name", agreementData.business_name);
    if (agreementData.image) {
      formData.append("image", agreementData.image);
    }

    const response = await fetchWithAuth(`/agreements/${agreementData.id_agreement}`, {
      method: 'PATCH',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error al editar el acuerdo:", error);
    throw error;
  }
};

export const deleteAgreement = async (id) => {
  try {
    const response = await fetchWithAuth(`/agreements/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error al eliminar el acuerdo:", error);
    throw error;
  }
};

// Función utilitaria (la puedes dejar igual si la necesitas en algún lado)
export function base64ToBlob(base64Data) {
  const matches = base64Data.match(/^data:(.+);base64,(.+)$/);
  if (!matches || matches.length !== 3) {
    throw new Error("Formato base64 no válido");
  }

  const mimeType = matches[1];
  const base64String = matches[2];

  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  return new Blob([byteArray], { type: mimeType });
}
